import { QueryClient } from 'react-query'

export const VesselQueryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      cacheTime: 5000 * 60, // 5 minutes
      staleTime: 5000 * 60, // 5 minutes
      retry: false,
    },
  },
})

export const queryCache = VesselQueryClient.getQueryCache()
export const mutationCache = VesselQueryClient.getMutationCache()
